import { Text } from '@sravni/react-design-system/lib/Typography';
import cn from 'classnames';

import { PARTNERS_IDS } from 'constants/partners';

import styles from './FormStepTitle.module.scss';

type TitleProps = { disabled?: boolean };

const AvitoTitle: FC<TitleProps> = ({ children, className, disabled, ...otherProps }) => {
  return (
    <Text
      className={cn(className, {
        [styles.titleDisabled]: disabled,
      })}
      size={16}
      {...otherProps}
    >
      {children}
    </Text>
  );
};

export const FormStepTitleConfig: Record<number, FC<TitleProps>> = {
  [PARTNERS_IDS.avito]: AvitoTitle,
} as const;
